export default httpClient => ({
  save: async ({ rede, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/paginas', rede, { headers })
    return {
      data: response.data,
    }
  },
  saveTopico: async ({ texto, titulo, pagina_id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/topicos', { texto, titulo, pagina_id }, { headers })
    return {
      data: response.data,
    }
  },
  update: async ({ id, texto, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/paginas/' + id, {
      id,
      texto,
    }, { headers });
    return {
      data: response.data
    }
  },
  updateTopico: async ({ id, texto, titulo, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/topicos/' + id, {
      id,
      texto,
      titulo,
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/paginas/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/paginas', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/paginas/' + id, { headers });
    return {
      data: response
    }
  },
  deleteTopicos: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/topicos/' + id, { headers });
    return {
      data: response
    }
  },
});